import { routes } from '~/constants';
export default function getManageIntegrationRoute(integration) {
    switch(integration.source){
        case 'xero':
            return routes.xeroSetup;
        case 'qbo':
            return routes.qboSetup;
        case 'financial-cents':
            return routes.financialCentsSetup;
        case 'karbon':
            return routes.karbonSetup;
        case 'client-hub':
            return routes.clientHubSetup;
        case 'keeper':
            return routes.keeperSetup;
        default:
            return routes.availableApps;
    }
}
